import { NgModule } from '@angular/core';

import { PhonePipe } from '../pipes/phone/phone';
import { MoneyPipe } from '../pipes/money/money';
import { YoutubePipe } from '../pipes/youtube/youtube';
import { FacebookPipe } from '../pipes/facebook/facebook.pipe';
import { VimeoPipe } from '../pipes/vimeo/vimeo.pipe';
import { Planos2arrayPipe } from '../pipes/planos2array/planos2array';
import { NomenclaturaPipe } from '../pipes/nomenclatura/nomenclatura';
import { ImagePipe } from '../pipes/image/image';
import { SafeHtmlPipe } from '../pipes/safe-html/safe-html';
import { EnderecoPipe } from '../pipes/endereco/endereco';
import { LimitToPipe } from '../pipes/limit-to/limit-to';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import { DatePickerModule } from 'ion-datepicker-3';
import { IonicSelectableModule } from 'ionic-selectable';

@NgModule({
  imports: [IonicSelectableModule],
  declarations: [
    PhonePipe,
    MoneyPipe,
    Planos2arrayPipe,
    NomenclaturaPipe,
    ImagePipe,
    SafeHtmlPipe,
    EnderecoPipe,
    YoutubePipe,
    FacebookPipe,
    VimeoPipe,
    LimitToPipe,
  ],
  exports: [
    PhonePipe,
    MoneyPipe,
    YoutubePipe,
    FacebookPipe,
    VimeoPipe,
    Planos2arrayPipe,
    NomenclaturaPipe,
    ImagePipe,
    SafeHtmlPipe,
    EnderecoPipe,
    TranslateModule,
    DatePickerModule,
    IonicSelectableModule,
    LimitToPipe,
  ],
  providers: [InAppBrowser],
})
export class SharedModule {}



// WEBPACK FOOTER //
// ./src/shared/shared.module.ts